import {Component, OnDestroy, OnInit} from '@angular/core';
import {Dac6ReporterApiService} from "../../../../services/dac6-reporter.service";
import {FormBuilder} from "@angular/forms";
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'particle-dac6-assign-transaction-cell-editor',
  templateUrl: './dac6-assign-transaction-cell-editor.component.html',
  styleUrls: ['./dac6-assign-transaction-cell-editor.component.scss']
})
export class Dac6AssignTransactionCellEditorComponent implements  OnInit, OnDestroy, IDialogView {
  data: DialogModel;
  cases: any;
  private task: any;
  allComplete =false;
  item: any;

  constructor(private dac6RepoterApiService: Dac6ReporterApiService, private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.item = this.data.input['item'];
    this.dac6RepoterApiService.getAvailableTransactionalArrangements().subscribe(cases=>{
      this.cases = cases;
      this.checkExisting();
    });
  }
  someComplete(): boolean {
    if (this.cases == null) {
      return false;
    }
    return this.cases.filter(t => t.checked).length > 0 && !this.allComplete;
  }
  setAll(checked: boolean) {
    this.allComplete = checked;
    if (this.cases == null) {
      return;
    }
    this.cases.forEach(t => t.checked = checked);
  }
  onOkClicked(): boolean {
   this.data.input['CaseIds'] = this.cases.filter(o=>o.checked).map(o=>o.caseId);
   return true;
  }

  onOtherButtonClicked(): boolean {
    throw new Error('Method not implemented.');
  }
  ngOnDestroy(): void {
    console.log('on destroy');
  }
  updateAllComplete() {
    this.allComplete = this.cases != null && this.cases.every(t => t.checked);
  }

  private checkExisting() {
    const assignedCases = this.item.cells[this.data.input['fieldDefinition'].key]
    if(assignedCases){
      this.cases = this.cases.map(o=>{
        if(assignedCases.value.find(i=>i === o.caseId)){
          return {
            ...o,
            checked: true
          };
        }
        return o;
      })
    }
  }
}
